import React from 'react'
import { node } from 'prop-types'
import styles from './PopoverBottomBar.module.scss'

export const PopoverBottomBar = ({ children }) => <div className={styles.wrapper}>{children}</div>

PopoverBottomBar.propTypes = {
  children: node.isRequired,
}
